<template lang="pug">
    div.sessionsList(v-if="sessions && sessions.length")
        v-layout(raw wrap)
            v-flex.mb-2(xs12)

                title-component.sessionsTitle(type="h4" :title="title")

            v-flex(xs12 sm6 md4 v-for="item in sessions"  :key="`${item.id}-block`")
                meditation-component(:item="item" :key="item.id")
</template>

<script>
    import Title from '~components/Title';
    import { mapActions } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        components: {
            TitleComponent: Title,
            MeditationComponent: () => import('../Meditation')
        },
        props: {
            session: VueTypes.object.default({}),
            title: VueTypes.string.def('')
        },
        data() {
            return {
                sessions: []
            };
        },
        async created() {
            this.sessions = await this.getRandomSessions(this.session);
        },
        methods: {
            ...mapActions('sessions', ['getRandomSessions'])
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'
    @import "../../assets/style/_mixins.styl"

    .sessionsList
        margin-top: 40px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .sessionsList
            margin-top: 30px

        .sessionsTitle
            font-size: 14px
</style>
